import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const lines = ["Stalking your competitor (politely)...", "Brainstorming scroll-stopping hooks...", "Mixing reels, carousels & stories...",
  "Sprinkling some Catalyst magic...", "Colour-coding your calendar...", "Almost there, adding the cherry on top..."];

export const Brewing = ({ name }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % lines.length), 3500);
    return () => clearInterval(t);
  }, []);
  return (
    <section data-testid="plan-brewing" className="px-6 py-20 flex flex-col items-center text-center">
      <div className="grid grid-cols-7 gap-2 mb-10">
        {Array.from({ length: 28 }).map((_, k) => (
          <motion.div key={k} className="h-8 w-8 md:h-10 md:w-10 rounded-lg"
            animate={{ backgroundColor: ["#d8dbce", ["#ffd84f", "#f6a5c0", "#b9e3d0", "#c7d2fe"][k % 4], "#d8dbce"] }}
            transition={{ duration: 2.4, repeat: Infinity, delay: k * 0.08 }} />
        ))}
      </div>
      <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight">
        Hang tight{name ? `, ${name}` : ""}! <em className="font-serif-cc font-normal">Your month is brewing.</em>
      </h2>
      <motion.p key={i} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="font-hand text-2xl text-[var(--green-2)] mt-4">
        {lines[i]}
      </motion.p>
      <p className="text-sm text-[var(--muted)] mt-6">Usually takes about 60–90 seconds — keep this tab open</p>
    </section>
  );
};
